'use client';
"use strict";

var _excluded = ["className", "layout"],
    _excluded2 = ["placement"],
    _excluded3 = ["overflow", "overflowX", "className"],
    _excluded4 = ["isNumeric"],
    _excluded5 = ["isNumeric"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Table: function Table() {
    return _Table;
  },
  TableCaption: function TableCaption() {
    return _TableCaption;
  },
  TableContainer: function TableContainer() {
    return _TableContainer;
  },
  Tbody: function Tbody() {
    return _Tbody;
  },
  Td: function Td() {
    return _Td;
  },
  Tfoot: function Tfoot() {
    return _Tfoot;
  },
  Th: function Th() {
    return _Th;
  },
  Thead: function Thead() {
    return _Thead;
  },
  Tr: function Tr() {
    return _Tr;
  },
  useTableStyles: function useTableStyles() {
    return _useTableStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/table.tsx

var import_system = require("@chakra-ui/system");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_react_context = require("@chakra-ui/react-context");

var import_jsx_runtime = require("react/jsx-runtime");

var _ref = (0, import_react_context.createContext)({
  name: "TableStylesContext",
  errorMessage: "useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Table />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    TableStylesProvider = _ref2[0],
    _useTableStyles = _ref2[1];

var _Table = (0, import_system.forwardRef)(function (props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Table", props);

  var _ref3 = (0, import_system.omitThemingProps)(props),
      className = _ref3.className,
      layout = _ref3.layout,
      tableProps = _objectWithoutProperties(_ref3, _excluded);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(TableStylesProvider, {
    value: styles,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.table, _objectSpread({
      ref: ref,
      __css: _objectSpread({
        tableLayout: layout
      }, styles.table),
      className: (0, import_shared_utils.cx)("chakra-table", className)
    }, tableProps))
  });
});

_Table.displayName = "Table"; // src/table-caption.tsx

var import_system2 = require("@chakra-ui/system");

var import_jsx_runtime2 = require("react/jsx-runtime");

var _TableCaption = (0, import_system2.forwardRef)(function (props, ref) {
  var _props$placement = props.placement,
      placement = _props$placement === void 0 ? "bottom" : _props$placement,
      rest = _objectWithoutProperties(props, _excluded2);

  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.caption, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: _objectSpread(_objectSpread({}, styles.caption), {}, {
      captionSide: placement
    })
  }));
});

_TableCaption.displayName = "TableCaption"; // src/table-container.tsx

var import_system3 = require("@chakra-ui/system");

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _TableContainer = (0, import_system3.forwardRef)(function (props, ref) {
  var _a;

  var overflow = props.overflow,
      overflowX = props.overflowX,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded3);

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils2.cx)("chakra-table__container", className)
  }, rest), {}, {
    __css: {
      display: "block",
      whiteSpace: "nowrap",
      WebkitOverflowScrolling: "touch",
      overflowX: (_a = overflow != null ? overflow : overflowX) != null ? _a : "auto",
      overflowY: "hidden",
      maxWidth: "100%"
    }
  }));
}); // src/tbody.tsx


var import_system4 = require("@chakra-ui/system");

var import_jsx_runtime4 = require("react/jsx-runtime");

var _Tbody = (0, import_system4.forwardRef)(function (props, ref) {
  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.tbody, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tbody
  }));
}); // src/td.tsx


var import_system5 = require("@chakra-ui/system");

var import_jsx_runtime5 = require("react/jsx-runtime");

var _Td = (0, import_system5.forwardRef)(function (_ref4, ref) {
  var isNumeric = _ref4.isNumeric,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system5.chakra.td, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: styles.td,
    "data-is-numeric": isNumeric
  }));
}); // src/tfooter.tsx


var import_system6 = require("@chakra-ui/system");

var import_jsx_runtime6 = require("react/jsx-runtime");

var _Tfoot = (0, import_system6.forwardRef)(function (props, ref) {
  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.tfoot, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tfoot
  }));
}); // src/th.tsx


var import_system7 = require("@chakra-ui/system");

var import_jsx_runtime7 = require("react/jsx-runtime");

var _Th = (0, import_system7.forwardRef)(function (_ref5, ref) {
  var isNumeric = _ref5.isNumeric,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_system7.chakra.th, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: styles.th,
    "data-is-numeric": isNumeric
  }));
}); // src/thead.tsx


var import_system8 = require("@chakra-ui/system");

var import_jsx_runtime8 = require("react/jsx-runtime");

var _Thead = (0, import_system8.forwardRef)(function (props, ref) {
  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_system8.chakra.thead, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.thead
  }));
}); // src/tr.tsx


var import_system9 = require("@chakra-ui/system");

var import_jsx_runtime9 = require("react/jsx-runtime");

var _Tr = (0, import_system9.forwardRef)(function (props, ref) {
  var styles = _useTableStyles();

  return /* @__PURE__ */(0, import_jsx_runtime9.jsx)(import_system9.chakra.tr, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tr
  }));
}); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  Table: _Table,
  TableCaption: _TableCaption,
  TableContainer: _TableContainer,
  Tbody: _Tbody,
  Td: _Td,
  Tfoot: _Tfoot,
  Th: _Th,
  Thead: _Thead,
  Tr: _Tr,
  useTableStyles: _useTableStyles
});